import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nbTranslations from "./locales/nb.json";
import enTranslations from "./locales/en.json";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations.translation },
      nb: { translation: nbTranslations.translation },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["navigator", "htmlTag", "path", "subdomain"],
      caches: ["localStorage", "cookie"],
    },
  });

i18n.loadNamespaces(["common"]);

export default i18n;
